/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Try_LaterInputs */

const en_common_try_later = /** @type {(inputs: Common_Try_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please try later or contact support center.`)
};

const es_common_try_later = /** @type {(inputs: Common_Try_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inténtalo más tarde o contacta soporte.`)
};

/**
* | output |
* | --- |
* | "Please try later or contact support center." |
*
* @param {Common_Try_LaterInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_try_later = /** @type {((inputs?: Common_Try_LaterInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Try_LaterInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_try_later(inputs)
	return en_common_try_later(inputs)
});